export const ONLY_LETTERS = /^[a-zA-ZñÑ]+$/;
export const LETTERS_NUMBERS_WITH_SPECIAL_CHARACTERS =
  /^[-' 0-9A-Za-záéíóúÁÉÍÓÚñÑüÜöÖëËäÄïÏãªç`àèìòùÀÈÌÒÙ ./´]*$/;
export const ONLY_LETTERS_AND_NUMBERS = /^[a-zA-Z 0-9]*$/;
export const LETTERS_WITH_SPECIAL_CHARACTERS =
  /^[-' A-Za-záéíóúÁÉÍÓÚñÑüÜöÖëËäÄïÏãªç`àèìòùÀÈÌÒÙ ./´]*$/;
export const REGEX_EMAIL = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
export const ONLY_LETTERS_WITH_ACCENT_AND_NUMBERS =
  /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s]*$/;
